﻿import { GuiAuswertung } from "./GuiAuswertung";
import { Chart } from "../chart-setup";
import { IChartData } from "../Interface/IChartData"
    export class GuiAuswertungKostenstelleMengeMonat extends GuiAuswertung {
        chartAnzahl?: Chart;

        constructor() {
            super("GuiAuswertungKostenstelleMengeMonat");
        }


        draw() {

            const ctx = document.getElementById("chart") as HTMLCanvasElement;
            if (this.chartAnzahl != undefined) {
                this.chartAnzahl.destroy();
            }

            const jsonData = (document.getElementById("jsonChartDataValues") as HTMLInputElement).value;
            if (jsonData == undefined || jsonData === "null") { return; }

            const chartData = JSON.parse(jsonData) as IChartData;
            const data = {
                labels: chartData.labels,
                datasets: [{
                    label: "Menge",
                    data: chartData.values,
                    backgroundColor:"#044135",
                    borderColor: "#044135",
                    hoverOffset: 4
                }, ...(chartData.values2 && chartData.values2.length > 0 ? [{
                    label: "Menge Vorjahr",
                    data: chartData.values2,
                    backgroundColor:"#0CAD8E",
                    borderColor: "#0CAD8E",
                    hoverOffset: 4
                }] : [])]
            };
            const config= this.CreateLineConfig(data);

            

            this.chartAnzahl = new Chart(ctx, config);
        }
    }
